export const WeatherActionTypes = {
  ADD_WEATHER_DATA: "ADD_WEATHER_DATA",
  ADD_COORDINATES: "ADD_COORDINATES",
};
